<div id="popup">
    <div class="title-head index-head" fxLayout="row" fxLayoutAlign="space-between center">
        <span style="color: white;">
            ADD FILES
        </span>
        <button [attr.guide]="'file-upload-popup-btn-1' + '__' + sanitizedUrl" mat-icon-button>
            <mat-icon (click)="close()">
                close
            </mat-icon>
        </button>
    </div>
    <mat-dialog-content [ngStyle.lt-md]="'max-height: 100%'" style=" MARGIN: 0PX; padding: 0px;">
        <div class="padding-11">
            <div fxLayout="column" style="overflow: auto;" [formGroup]="firstFormGroup">


                <div class="padding-10" fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">
                    Upload from your device
                </div>

                <mat-card class="mb-3 p-2 bg-blue-50 border border-blue-200" fxLayout="row" fxLayoutAlign="start center"
                    fxLayoutGap="10px">
                    <mat-icon color="primary">info</mat-icon>
                    <div>
                        Maximum file size is <strong>16 MB</strong>.
                        Files attached can be accessed by any user viewing this
                        {{ type === 1 ? 'Lead' : 'Company' }}.
                    </div>
                </mat-card>


                <div class="padding-10" *ngIf="!selectedFile" class="upload-zone"
                    [ngClass]="{'file-over': hasBaseDropZoneOver}" ng2FileDrop [uploader]="uploader"
                    (fileOver)="fileOverBase($event)">
                    <label for="fileInput" class="upload-label">
                        <span class="clickable-text">Upload your file here</span>
                    </label>
                    <input [attr.guide]="'file-upload-popup-inp-fileinput' + '__' + sanitizedUrl" #myInput type="file"
                        id="fileInput" ng2FileSelect [uploader]="uploader" hidden />
                    <div class="or-divider">— or —</div>
                    <div>Drag your file</div>
                </div>

                <div *ngIf="selectedFile" class="padding-10 file-preview">
                    <div class="file-row">
                        <mat-icon>insert_drive_file</mat-icon>
                        <span>{{ fileName }}</span>
                        <a [attr.guide]="'file-upload-popup-lnk-2' + '__' + sanitizedUrl" class="remove-link"
                            (click)="removeFile()">Remove</a>
                    </div>
                </div>



                <div *ngIf="selectedFile" class="padding-10">
                    <mat-form-field appearance="outline" fxFlex="100">
                        <mat-label>File name</mat-label>
                        <input [attr.guide]="'file-upload-popup-inp-notesdocument' + '__' + sanitizedUrl"
                            [autocomplete]="'off'" trim="blur" matInput formControlName="notesDocument" readonly />
                    </mat-form-field>
                </div>

                <div *ngIf="selectedFile" class="padding-10">
                    <!-- <mat-form-field appearance="outline" fxFlex="100">
                        <mat-label>Tag User</mat-label>
                        <input [attr.guide]="'file-upload-popup-inp-taggeduser' + '__' + sanitizedUrl" [autocomplete]="'off'" trim="blur" matInput formControlName="taggedUser"/>
                    </mat-form-field> -->
                </div>


                <mat-progress-bar *ngIf="uploadInProgress" mode="indeterminate"></mat-progress-bar>



            </div>
            <div class="padding-top10" fxLayoutAlign="end center" fxLayoutGap="10px">
                <div fxLayoutGap="10px" class="padding-top10">

                    <span>
                        NOTE: Files added here will be associated to this {{type == 1 ? 'Lead' : 'Company'}}.
                    </span>
                    <button [attr.guide]="'file-upload-popup-btn-3' + '__' + sanitizedUrl" type="button"
                        mat-raised-button (click)="close()">Cancel</button>

                    <ng-container *ngIf="buttonEnable">
                        <button [attr.guide]="'file-upload-popup-btn-4' + '__' + sanitizedUrl"
                            [disabled]="text != 'Add'" (click)="submit()" mat-raised-button>
                            {{ text }}
                        </button>
                    </ng-container>

                    <ng-container *ngIf="!buttonEnable">
                        <button [attr.guide]="'file-upload-popup-btn-5' + '__' + sanitizedUrl"
                            [disabled]="!buttonEnable" (click)="submit()" mat-raised-button>
                            {{ text }}
                        </button>
                    </ng-container>

                </div>
            </div>
        </div>
    </mat-dialog-content>
</div>